import { render } from "./PunctualityReport.vue?vue&type=template&id=1c6c0d70&scoped=true"
import script from "./PunctualityReport.vue?vue&type=script&lang=js"
export * from "./PunctualityReport.vue?vue&type=script&lang=js"

import "../../components/timesheet.scss?vue&type=style&index=0&id=1c6c0d70&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6c0d70"]])

export default __exports__